// import redirectFnWithBaseFactory from '~packages/mkskom-router/redirectFnWithBase.factory';
import getConstants from '@/constants';

import { defaultPath, routes } from './app/routes';

export { defaultPath };
const { routerBasePath } = getConstants();

const basePath =
  routerBasePath[routerBasePath.length - 1] === '/'
    ? routerBasePath.slice(0, -1)
    : routerBasePath;

const defaultPathWithBase = `${basePath}${defaultPath}`;
// const ntAddRedirectHandler = !isModeDevelopment && routerBasePath !== '/';

export default [
  ...routes.map(i => ({ ...i, path: `${basePath}${i.path}` })),
  {
    path: '/:pathMatch(.*)*',
    redirect: defaultPathWithBase,
    // redirect: ntAddRedirectHandler
    //   ? redirectFnWithBaseFactory(routes, defaultPath, basePath)
    //   : defaultPathWithBase,
  },
];
